"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
exports.makeUniform = function (vector) {
    var e_1, _a;
    var uniformVec = vector.clone();
    try {
        for (var _b = __values(["x", "y", "z"]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var axis = _c.value;
            if (uniformVec[axis] !== 0) {
                uniformVec[axis] /= Math.abs(uniformVec[axis]);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return uniformVec;
};
exports.makeAbs = function (vector) {
    var e_2, _a;
    var absVect = vector.clone();
    try {
        for (var _b = __values(["x", "y", "z"]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var axis = _c.value;
            absVect[axis] = Math.abs(absVect[axis]);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return absVect;
};
exports.alignOnYAxis = function (mesh, targetPos) {
    var newTargetPos = targetPos.multiplyByFloats(1, 0, 1);
    var meshPos = mesh.getAbsolutePosition().multiplyByFloats(1, 0, 1);
    var normal = meshPos.subtract(newTargetPos).normalize();
    mesh.alignWithNormal(normal);
    mesh.rotate(babylonjs_1.Axis.Z, babylonjs_1.Angle.FromDegrees(-90).radians());
    mesh.rotate(babylonjs_1.Axis.Y, babylonjs_1.Angle.FromDegrees(-90).radians());
};
